const joinClassNames = (...parts) => parts.filter(Boolean).join(' ')

export default function ActionButtonRow({ children, className = '' }) {
  return <div className={joinClassNames('gg-action-row gg-action-row--spaced', className)}>{children}</div>
}
